exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n@font-face {\n  font-family: \"CricHQ-With-BandAid\";\n  src: url(" + require("./assets/fonts/GOTHIC.ttf") + ") format(\"truetype\");\n}\n\nhtml * {\n  margin:0;\n  padding:0;\n  box-sizing:border-box;\n  font-family: \"Century Gothic\" !important;\n}\n\n\nbody {\n  background-color: #edecf8;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = 390
// module chunks = 3